webpackJsonp([118551011512839],{

/***/ 34:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	__webpack_require__(14);
	
	__webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	}
	
	var ContactCouncilForm = function (_Component) {
	  _inherits(ContactCouncilForm, _Component);
	
	  function ContactCouncilForm(props) {
	    _classCallCheck(this, ContactCouncilForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var form = e.target;
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode(_extends({
	          'form-name': form.getAttribute('name')
	        }, _this.state))
	      }).then(function () {
	        return (0, _gatsbyLink.navigateTo)(form.getAttribute('action'));
	      }).catch(function (error) {
	        return alert(error);
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  ContactCouncilForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      'form',
	      {
	        name: 'signup',
	        className: 'form-inline',
	        method: 'post',
	        action: '/thanks/',
	        'data-netlify': 'true',
	        'data-netlify-honeypot': 'bot-field',
	        onSubmit: this.handleSubmit
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'signup' }),
	      _react2.default.createElement(
	        'p',
	        { hidden: true },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Don\u2019t fill this out:',
	          ' ',
	          _react2.default.createElement('input', { name: 'bot-field', onChange: this.handleChange })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group row p-3 p-md-4 container' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'col-12 mb-3', style: { textAlign: 'center' } },
	          'Stay up to date with our campaign'
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'sr-only', htmlFor: 'email' },
	          'Email'
	        ),
	        _react2.default.createElement('input', {
	          className: 'form-control form-control-lg col-12 mb-2',
	          name: 'email',
	          type: 'text',
	          placeholder: 'Email',
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(
	          'label',
	          { className: 'sr-only', htmlFor: 'zipcode' },
	          'Zipcode'
	        ),
	        _react2.default.createElement('input', {
	          className: 'form-control form-control-lg col-12 mb-2',
	          name: 'zipcode',
	          type: 'text',
	          placeholder: 'Zipcode',
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(
	          'label',
	          { className: 'sr-only', htmlFor: 'publicSupport' },
	          'Would you like to be listed as a public supporter?'
	        ),
	        _react2.default.createElement(
	          'select',
	          {
	            className: 'custom-select mb-2 col-12 form-control form-control-lg',
	            name: 'publicSupport',
	            onChange: this.handleChange,
	            defaultValue: 0
	          },
	          _react2.default.createElement(
	            'option',
	            { value: 0 },
	            'Show me as a public supporter?'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'yes' },
	            'Yes'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'no' },
	            'No'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'col-12 mb-2 btn btn-success btn-lg', type: 'submit' },
	          'Submit'
	        )
	      )
	    );
	  };
	
	  return ContactCouncilForm;
	}(_react.Component);
	
	exports.default = ContactCouncilForm;
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/VoteYay_Long_4C.1926b6e8.png";

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Foster_FINAL.ad3c5122.mp4";

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Foster_FINAL.e8ba8c53.webm";

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Jessica_Foster_Frame.2e924cde.jpg";

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EndorsementForm = __webpack_require__(38);
	
	var _EndorsementForm2 = _interopRequireDefault(_EndorsementForm);
	
	var _StoryForm = __webpack_require__(26);
	
	var _StoryForm2 = _interopRequireDefault(_StoryForm);
	
	var _gatsbyImage = __webpack_require__(8);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Foster_FINAL = __webpack_require__(365);
	
	var _Foster_FINAL2 = _interopRequireDefault(_Foster_FINAL);
	
	var _Foster_FINAL3 = __webpack_require__(366);
	
	var _Foster_FINAL4 = _interopRequireDefault(_Foster_FINAL3);
	
	var _Jessica_Foster_Frame = __webpack_require__(367);
	
	var _Jessica_Foster_Frame2 = _interopRequireDefault(_Jessica_Foster_Frame);
	
	var _VoteYay_Long_4C = __webpack_require__(36);
	
	var _VoteYay_Long_4C2 = _interopRequireDefault(_VoteYay_Long_4C);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jessicaStory = {
	  header: 'Jessica Foster\'s Story',
	  headline: '"I\'m in disbelief that public school teachers qualify for Habitat for Humanity."',
	  story: [{
	    text: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Jessica Foster is an elementary school teacher for AISD. Since moving to Austin, she has not been able to afford to live close to the community she educates.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'She\'s lived in cramped, sub-standard apartments that have left her housing-cost burdened because of how much of her income she spends on rent. There have been times where her car breaks down and she can\'t afford to fix it for months and she\'s continually struggling to make her student loan payments.'
	      )
	    ),
	    media: _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'video',
	        { controls: true, style: { width: '100%', border: '3px solid black' } },
	        _react2.default.createElement('source', { src: _Foster_FINAL2.default, type: 'video/mp4' }),
	        _react2.default.createElement('source', { src: _Foster_FINAL4.default, type: 'video/webm' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your browser doesn\'t support HTML5 video. Here is a',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: _Foster_FINAL2.default },
	            'link to the video'
	          ),
	          ' instead.'
	        )
	      )
	    )
	  }, {
	    text: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'All of this is about to change for Jessica.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Through Austin Habitat for Humanity, Jessica will begin building her very own affordable home this November down the street from the school she teaches in. She\'ll get to live in the same community as her students, forge deeper bonds with their families, and finally make headway on her student debt.'
	      )
	    ),
	    media: ''
	  }, {
	    text: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Teachers in Austin would need to make almost double their average salary to afford a market-rate home in Austin. We need to invest in affordable housing programs now before we push our educators out and only upper-income people can afford to live here.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The land Jessica\'s home is being built on was purchased by Austin Habitat with the help of City funding -- the type of funding Proposition A, the Affordable Housing Bond, will provide.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Through the Affordable Housing Bond, we can keep our teachers in Austin. We can make an Austin everyone can afford.',
	        ' '
	      )
	    ),
	    media: _react2.default.createElement(
	      'span',
	      null,
	      'todo'
	    )
	  }],
	  callToAction: _react2.default.createElement(
	    'div',
	    { style: { textAlign: 'center' } },
	    _react2.default.createElement('img', {
	      src: _VoteYay_Long_4C2.default,
	      alt: 'Vote Yay for Prop A',
	      style: { maxWidth: '100%', marginBottom: '20px' }
	    }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Vote Yay for Prop A on November 6th.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Do it for your neighbors. Do it for teachers like the Jessica.'
	    )
	  )
	};
	
	var JessicFosterStory = function JessicFosterStory(props) {
	  return _react2.default.createElement(StoryTemplate, {
	    header: jessicaStory.header,
	    headline: jessicaStory.headline,
	    story: jessicaStory.story,
	    callToAction: jessicaStory.callToAction,
	    primaryImage: props.data.jessicaStory.sizes,
	    secondaryImage: props.data.jessicaStory2.sizes,
	    thirdImage: props.data.habitat.sizes
	  });
	};
	
	var StoryHeader = function StoryHeader(_ref) {
	  var header = _ref.header,
	      headline = _ref.headline,
	      primaryImage = _ref.primaryImage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      { className: 'mb-4' },
	      header
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm', style: { textAlign: 'center' } },
	        _react2.default.createElement(
	          'video',
	          { controls: true, style: { width: '100%', border: '3px solid black' } },
	          _react2.default.createElement('source', { src: _Foster_FINAL2.default, type: 'video/mp4' }),
	          _react2.default.createElement('source', { src: _Foster_FINAL4.default, type: 'video/webm' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Your browser doesn\'t support HTML5 video. Here is a',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: _Foster_FINAL2.default },
	              'link to the video'
	            ),
	            ' instead.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'col' },
	        headline
	      )
	    )
	  );
	};
	
	var StoryTemplate = function StoryTemplate(_ref2) {
	  var header = _ref2.header,
	      headline = _ref2.headline,
	      body1 = _ref2.body1,
	      body2 = _ref2.body2,
	      story = _ref2.story,
	      callToAction = _ref2.callToAction,
	      primaryImage = _ref2.primaryImage,
	      secondaryImage = _ref2.secondaryImage,
	      thirdImage = _ref2.thirdImage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'StoryTemplate container py-4' },
	    _react2.default.createElement(StoryHeader, {
	      header: header,
	      headline: headline,
	      primaryImage: primaryImage
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'row py-4' },
	      _react2.default.createElement('div', {
	        className: 'col',
	        style: { borderRight: '4px dashed black', height: '100px' }
	      }),
	      _react2.default.createElement('div', { className: 'col' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm' },
	        story[0].text
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm' },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          title: 'Father holding infant baby',
	          alt: 'Father holding infant baby',
	          sizes: secondaryImage,
	          style: {
	            width: '100%',
	            maxHeight: '90vh',
	            border: '3px solid black'
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row py-4' },
	      _react2.default.createElement('div', {
	        className: 'col',
	        style: { borderRight: '3px dashed black', height: '100px' }
	      }),
	      _react2.default.createElement('div', { className: 'col' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm', style: { textAlign: 'center' } },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          title: 'Father holding infant baby',
	          alt: 'Father holding infant baby',
	          sizes: thirdImage,
	          style: {
	            width: '100%',
	            maxHeight: '90vh',
	            border: '3px solid black'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm' },
	        story[1].text
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row py-4' },
	      _react2.default.createElement('div', {
	        className: 'col',
	        style: { borderRight: '3px dashed black', height: '100px' }
	      }),
	      _react2.default.createElement('div', { className: 'col' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm' },
	        story[2].text
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm', style: { textAlign: 'center' } },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          title: 'Richard Overton, World War II Veteran',
	          alt: 'Richard Overton, World War II Veteran',
	          sizes: primaryImage,
	          style: {
	            width: '100%',
	            maxHeight: '90vh',
	            border: '3px solid black',
	            marginBottom: '20px'
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row py-4' },
	      _react2.default.createElement('div', {
	        className: 'col',
	        style: { borderRight: '3px dashed black', height: '100px' }
	      }),
	      _react2.default.createElement('div', { className: 'col' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      callToAction,
	      _react2.default.createElement(_StoryForm2.default, null)
	    )
	  );
	};
	
	exports.default = JessicFosterStory;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-stories-jessica-foster-js-cd65a5cff3ef5ad429f7.js